/** @jsxImportSource @emotion/react */
import React from 'react'
import colors from '@sportninja/common/constants/appColors'

interface PlayArrowIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: number
  color?: string
}

const PlayArrowIcon: React.FC<PlayArrowIconProps> = ({
  size = 16,
  color = colors.WHITE,
  className,
  style,
  ...rest
}) => {
  return (
    <span className={`anticon ${className || ''}`} style={style} {...rest}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 -960 960 960'
        fill={color}
      >
        <path d='M320-200v-560l440 280-440 280Z' />
      </svg>
    </span>
  )
}

export default PlayArrowIcon
